import { clsx } from 'clsx'

import { Table } from '@buffer-mono/popcorn'

import type { ListItem } from './helpers'
import { PostItem } from './PostItem'

import styles from './PostItemsTable.module.css'

export const PostItemsTable = ({
  items,
  twentyFourHourFormat,
  channelTimezone,
}: {
  items: ListItem[]
  twentyFourHourFormat: boolean
  channelTimezone: string
}): JSX.Element => {
  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell
            className={clsx(styles.tableHeader, styles.indexHeader)}
          >
            #
          </Table.HeaderCell>
          <Table.HeaderCell
            className={clsx(styles.tableHeader, styles.textHeader)}
          >
            Text
          </Table.HeaderCell>
          <Table.HeaderCell
            className={clsx(styles.tableHeader, styles.imageHeader)}
          >
            Image
          </Table.HeaderCell>
          <Table.HeaderCell
            className={clsx(styles.tableHeader, styles.tagsHeader)}
          >
            Tags
          </Table.HeaderCell>
          <Table.HeaderCell
            className={clsx(styles.tableHeader, styles.postingTimeHeader)}
          >
            Posting Time
          </Table.HeaderCell>
          <Table.HeaderCell
            className={clsx(styles.tableHeader, styles.statusHeader)}
          >
            Status
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {items.map((item, index) => (
          <PostItem
            key={item.id}
            item={item}
            index={index}
            twentyFourHourFormat={twentyFourHourFormat}
            channelTimezone={channelTimezone}
          />
        ))}
      </Table.Body>
    </Table>
  )
}
